import { computed } from 'vue';
import { usePermissions } from './usePermissions';
import { useAuthStore } from '@/stores/auth.store';

export function useHarasListAccess() {
  const { hasRole } = usePermissions();
  const authStore = useAuthStore();

  const canAccessHarasList = computed(() => {
    const adminRoles = ['SUPER_ADMIN', 'ADMIN', 'DIRECTEUR', 'CHEF_BUREAU'];

    // Check if user has admin roles
    const isAdmin = hasRole(adminRoles);
    if (isAdmin) return true;

    // For REPRESENTANT_HARAS_REGIONAL, only allow if haras is PUBLIC
    const isRepresentantHaras = hasRole('REPRESENTANT_HARAS_REGIONAL');
    if (isRepresentantHaras) {
      const harasType = authStore.user?.haras?.type_haras;
      return harasType === 'PUBLIC';
    }

    return false;
  });

  return {
    canAccessHarasList,
  };
}
